import { type FC } from 'react';

import { TextLogo } from '@livechat/design-system-icons';
import { Button, Icon, NavigationTopBarAlert } from '@livechat/design-system-react-components';

import { TopBarNotificationType } from 'constants/notifications';
import { trackTextPromoClick } from 'helpers/text-promo';
import { openChatWidget, sendMessage } from 'services/chat-widget';

import * as styles from './styles';

interface Props {
  isVisible: boolean;
  onDismiss(): void;
  onSkip(name: TopBarNotificationType): void;
}

export const TextPromoBar: FC<Props> = ({ isVisible, onDismiss, onSkip }) => {
  const handleInterested = (): void => {
    openChatWidget();
    sendMessage("I'm interested in moving to Text");
    trackTextPromoClick('top_banner', 'chat');
    onDismiss();
  };

  const handleSkip = (): void => {
    onDismiss();
    onSkip(TopBarNotificationType.TextPromo);
  };

  return (
    <NavigationTopBarAlert
      isVisible={isVisible}
      className={styles.banner}
      closeButton={{
        onClick: handleSkip,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'aria-label': 'Close Text promo banner',
      }}
    >
      <div className={styles.content}>
        <span className={styles.message}>
          <Icon source={TextLogo} size="medium" />
          <span>Upgrade to Text for free. The new platform by LiveChat with an AI Agent, tickets, and more.</span>
        </span>
        <Button kind="secondary" size="compact" className={styles.action} onClick={handleInterested}>
          {"I'm interested"}
        </Button>
      </div>
    </NavigationTopBarAlert>
  );
};
